import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3546f23a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row space-x-3" }
const _hoisted_2 = { class: "text-lg" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col py-2 space-y-3"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 pr-1 space-y-2 overflow-y-auto custumScroll"
}

import useAccess from "@/composable/useAccess";
import { isFeatureKeyOn } from "@/composable/useEnterpriseFeature";
import { storageConfig } from "@/state/api/userState";
	import { ref, watch, onBeforeMount } from "vue";
	import {  useRoute } from "vue-router";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuLink',
  props: {
		name: {
			type: String,
			default: "",
		},
		title: {
			type: Object,
			default: {},
		},
		routeName: {
			type: String,
			default: "",
		},
		icon: {
			type: Object,
			default: {},
		},
		subMenu: {
			type: Array,
			default: [],
		},
		collapsed: {
			// Mode rail : icône seule + flyout des sous-menus au survol.
			type: Boolean,
			default: false,
		},
		userRoles: {
			type: Array,
			default: [],
		},
		resources: {
			type: Array,
			default: [],
		},
		permissions: {
			type: Array,
			default: [],
		},
		featureFlag: {
			// Registry feature key (dot.notation, e.g. `module.planning`)
			// gating the entire group. Empty string = no gate (always visible).
			type: String,
			default: "",
		},
	},
  setup(__props) {

	const isOpen: any = ref(false);
	const route = useRoute();
	const currentPath = ref(route.path);
	const formatedCurrentPath = ref();

	const props = __props;

	/**
	 * Variables
	 */
	const permission = ref(true);
	const isCurrentPath = ref(false);

	/**
	 * Pour chaque changement de route, on met à jour le currentPath
	 * et on met à jour le formatedCurrentPath
	 *
	 * @return {void}
	 */
	watch(() => route.path, () => {
		currentPath.value = route.path;
		formatPath();
	})

	/**
	 * Functions
	 */
	/**
	 * Cette fonction Formate essentiellement le currentPath
	 * Puis verifie pour chaque bloc de menu, si le currentPath fait partie d'un element du sous bloc,
	 * Si oui, on met à jour isCurrentPath (activer le focus sur le bloc) et isOpen (ouvrir le bloc) à true
	 * Si non, on ferme les autres bloc et on retire le focus sur les autres blocs
	 *
	 * @return {void}
	 */
	const formatPath = () => {
		const parts = currentPath.value.split("/");
		formatedCurrentPath.value = parts.slice(1).join('-');

		for (const subMenuItem of props.subMenu as any) {
			if (subMenuItem.route == formatedCurrentPath.value) {
				isCurrentPath.value = true;
				isOpen.value = true;
				break;
			} else {
				isCurrentPath.value = false;
				isOpen.value = false;
			}
		}
	};

	/**
	 * Component lifecycle
	 */
	onBeforeMount(() => {
		//
		formatPath();
	});

	const checkAccess = (resources: any) => {
		return  useAccess("resource", resources);
	}

	// Role-level gate (e.g. only Root). Empty array means "no role restriction".
	// Root users are always allowed (useAccess short-circuits to true for Root).
	const checkRoles = (roles: any) => {
		if (!roles || (roles as any).length === 0) return true;
		return useAccess("visibility", roles);
	}

	/**
	 * Flyout (mode rail) — téléporté dans <body> pour échapper au clipping du
	 * rail scrollable ET à tout ancêtre transformé (sinon `position:fixed` se
	 * calerait sur l'ancêtre). Position + hauteur max calculées pour rester DANS
	 * le viewport même sur petit écran → la liste des sous-menus reste scrollable
	 * et la barre de défilement toujours atteignable.
	 */
	const showFlyout = ref(false);
	const itemRef = ref<any>(null);
	const flyoutStyle = ref<any>({});
	let closeTimer: any = null;

	const openFlyout = () => {
		if (!props.collapsed) return;
		clearTimeout(closeTimer);
		const el = itemRef.value;
		if (el && el.getBoundingClientRect) {
			const r = el.getBoundingClientRect();
			const margin = 10;
			const vh = window.innerHeight;
			const left = r.right + 8;
			// hauteur dispo la plus grande entre "sous le centre" et tout le viewport
			const maxHeight = vh - 2 * margin;
			// centré sur l'icône, puis clampé dans [margin, vh - margin]
			let top = r.top + r.height / 2 - Math.min(maxHeight, 520) / 2;
			if (top < margin) top = margin;
			flyoutStyle.value = {
				position: "fixed",
				left: `${left}px`,
				top: `${top}px`,
				maxHeight: `${maxHeight}px`,
			};
		}
		showFlyout.value = true;
	};
	const keepFlyout = () => clearTimeout(closeTimer);
	const scheduleCloseFlyout = () => {
		closeTimer = setTimeout(() => (showFlyout.value = false), 160);
	};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SubMenuLink = _resolveComponent("SubMenuLink")!

  return (_unref(isFeatureKeyOn)(__props.featureFlag) && checkAccess(__props.resources) && checkRoles(__props.userRoles))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "itemRef",
        ref: itemRef,
        onMouseenter: openFlyout,
        onMouseleave: scheduleCloseFlyout,
        class: _normalizeClass({
			'rounded-lg focus-within:bg-[#2D334A]': true,
			'flex flex-col py-2 px-3': !__props.collapsed,
			'relative flex justify-center py-1': __props.collapsed,
			'enable-bg-color': __props.routeName == formatedCurrentPath.value || isCurrentPath.value,
		})
      }, [
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.name != 'profile' && __props.name != 'settings' && __props.name != 'logout')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: __props.routeName },
                    tag: "a",
                    class: _normalizeClass([
					{
						'font-normal rounded-lg py-0 px-3  peer hover:text-accent text-white flex flex-row items-center justify-between': true,
						'opacity-30':
							__props.name != 'profile' && __props.name != 'settings' && __props.name != 'logout' ? !permission.value : false,
					},
				]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        (__props.icon != {})
                          ? (_openBlock(), _createBlock(_component_Icon, {
                              key: 0,
                              src: __props.icon.active,
                              css: "w-6 h-6"
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(storageConfig)?.lang ? __props.title[_unref(storageConfig).lang] : __props.title.en), 1)
                      ]),
                      (__props.subMenu.length != 0)
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 0,
                            src: "/media/icons/arrow-down-icon.svg",
                            css: "w-6 h-6"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["to", "class"]))
                : _createCommentVNode("", true),
              (isOpen.value && __props.subMenu.length != 0)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.subMenu as any), (item, index) => {
                      return (_openBlock(), _createBlock(_component_SubMenuLink, {
                        key: index,
                        title: item.title,
                        icon: __props.icon,
                        featureFlag: item.feature_flag ?? '',
                        routeName: item.route,
                        indexMenu: index,
                        resources: item.allowed_resources,
                        userRoles: item.user_roles ?? []
                      }, null, 8, ["title", "icon", "featureFlag", "routeName", "indexMenu", "resources", "userRoles"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (__props.name != 'profile' && __props.name != 'settings' && __props.name != 'logout')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: __props.routeName },
                    tag: "a",
                    class: "flex items-center justify-center w-12 h-12 text-white rounded-lg peer hover:bg-[#2D334A] hover:text-accent"
                  }, {
                    default: _withCtx(() => [
                      (__props.icon != {})
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 0,
                            src: __props.icon.active,
                            css: "w-6 h-6"
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _withDirectives(_createElementVNode("div", {
                  style: _normalizeStyle(flyoutStyle.value),
                  onMouseenter: keepFlyout,
                  onMouseleave: scheduleCloseFlyout,
                  class: "z-[100] flex flex-col min-w-[240px] p-3 shadow-2xl rounded-xl bg-[#2D313E] ring-1 ring-black/40"
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: __props.routeName },
                    class: "flex-none px-3 py-2 mb-1 font-semibold text-white rounded-md hover:text-accent hover:bg-[#2D334A]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(storageConfig)?.lang ? __props.title[_unref(storageConfig).lang] : __props.title.en), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  (__props.subMenu.length != 0)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.subMenu as any), (item, index) => {
                          return (_openBlock(), _createBlock(_component_SubMenuLink, {
                            key: index,
                            title: item.title,
                            icon: __props.icon,
                            featureFlag: item.feature_flag ?? '',
                            routeName: item.route,
                            indexMenu: index,
                            resources: item.allowed_resources,
                            userRoles: item.user_roles ?? []
                          }, null, 8, ["title", "icon", "featureFlag", "routeName", "indexMenu", "resources", "userRoles"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 36), [
                  [_vShow, showFlyout.value]
                ])
              ]))
            ], 64))
      ], 34))
    : _createCommentVNode("", true)
}
}

})